import {Spinner} from '../Spinner';
import {Typography} from '../Typography';

import type {FC, ReactNode} from 'react';

export interface ContentSectionProps {
  title: string;
  titleBadge?: ReactNode;
  subtitle?: string;
  action?: ReactNode;
  isLoading?: boolean;
  children?: ReactNode;
}

export const ContentSection: FC<ContentSectionProps> = ({
  title,
  titleBadge,
  subtitle,
  action,
  isLoading,
  children
}) => {
  return (
    <div data-slot="content-section" className="flex flex-col gap-6">
      <div className="flex items-center gap-6">
        <div className="flex flex-1 flex-col gap-0.5 text-start">
          <div className="flex items-center gap-2">
            <Typography as="h2" size="md" weight="semibold">
              {title}
            </Typography>
            {titleBadge}
          </div>
          {subtitle && (
            <Typography as="p" size="sm" color="tertiary">
              {subtitle}
            </Typography>
          )}
        </div>
        {action}
      </div>
      {isLoading ? <Spinner aria-label={title} /> : children}
    </div>
  );
};
